<template>
  <div :style="'width:' + this.width">
    {{id}}
    <div v-if="elements.length > 0"  class="slideshow-container">

      <div v-for="element in elements" v-bind:key="element.id" class="MySlides fade" :class="name">
        <div class="numbertext">{{ element.id }} / {{ elements.length }}</div>
        <img :src="'https://static.igem.wiki/teams/4185/wiki/' + element.src">
        <div class="text">{{ element.caption }}</div>
      </div>

      <!-- <div class="mySlides fade">
        <div class="numbertext">2 / 3</div>
        <img src="../assets/img/img_snow_wide.jpg">
        <div class="text">Caption Two</div>
      </div>

      <div class="mySlides fade">
        <div class="numbertext">3 / 3</div>
        <img src="../assets/img/img_mountains_wide.jpg">
        <div class="text">Caption Three</div>
      </div> -->

      <a class="prev" @click="plusSlides(-1)">❮</a>
      <a class="next" @click="plusSlides(1)">❯</a>
    </div>
    <br>

    <div style="text-align:center">
      <span v-for="element in elements" v-bind:key="element.id" class="dot" :class="'dot' + name" @click="currentSlide(element.id)"></span> 
      <!-- <span class="dot" @click="currentSlide(2)"></span> 
      <span class="dot" @click="currentSlide(3)"></span> -->
    </div>
  </div>
</template>

<script>
export default {
    props: ['name', 'width', 'elements'],
    data () {
      return {
        slideIndex: 1
      }
    },
    mounted () {
      this.showSlides(this.slideIndex)
    },
    methods: {
    plusSlides(n) {
      this.showSlides(this.slideIndex += n);
    },
    currentSlide(n) {
      this.showSlides(this.slideIndex = n);
    },
    showSlides(n) {
        let i;
        let slides = document.getElementsByClassName(this.name);
        let dots = document.getElementsByClassName("dot" + this.name);

        if (n > slides.length) {this.slideIndex = 1}    
        if (n < 1) {this.slideIndex = slides.length}
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";  
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[this.slideIndex-1].style.display = "block";  
        dots[this.slideIndex-1].className += " active";
        }
    }
}
</script>

<style lang="scss">
    * {box-sizing: border-box}
    body {font-family: Verdana, sans-serif; margin:0}
    .mySlides {display: none}
    img {vertical-align: middle; width: -webkit-fill-available;}

    /* Slideshow container */
    .slideshow-container {
    // max-width: 1000px;
    position: relative;
    margin: auto;


    /* Next & previous buttons */
    .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    padding: 16px;
    margin-top: -22px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
    }

    /* Position the "next button" to the right */
    .next {
    right: 0;
    border-radius: 3px 0 0 3px;
    }

    /* On hover, add a black background color with a little bit see-through */
    .prev:hover, .next:hover {
    background-color: rgba(0,0,0,0.8);
    }

    /* Caption text */
    .text {
    color: #f2f2f2;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
    width: -webkit-fill-available;
    }

    /* Number text (1/3 etc) */
    .numbertext {
    color: #f2f2f2;
    font-size: 12px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
    }

    /* Fading animation */
    .fade {
    animation-name: fade;
    animation-duration: 1.5s;
    }

    @keyframes fade {
    from {opacity: .4} 
    to {opacity: 1}
    }

    /* On smaller screens, decrease text size */
    @media only screen and (max-width: 300px) {
    .prev, .next,.text {font-size: 11px}
    }


    }

     /* The dots/bullets/indicators */
    .dot {
    cursor: pointer;
    height: 15px;
    width: 15px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
    }

    .active, .dot:hover {
    background-color: #717171;
    }
</style>